import * as THREE from "three";
import type { FrameContext, RuntimeSystem, WorldQuery } from "../core/types";

export class AmbientLifeSystem implements RuntimeSystem {
  readonly root = new THREE.Group();
  private readonly scene: THREE.Scene;
  private disposed = false;

  constructor(scene: THREE.Scene, _world: WorldQuery, _seed: string) {
    this.scene = scene;
    this.root.name = "ambient-life";
    this.scene.add(this.root);
  }

  update(_frame: FrameContext): void {}

  dispose(): void {
    if (this.disposed) return;
    this.disposed = true;
    this.scene.remove(this.root);
  }
}
